// Render plugin for `skill_hoisted` SSE events.
//
// hoist_skill writes a skill bundle and the host catalogs it as the person's
// private draft (or, for a Manager who asked, the organisation's skill). The
// core reducer keeps the chat's last hoist for the Skills tab; this plugin
// draws a card under each hoist_skill call with a one-click Save to My skills
// (SkillDraftCard). Event data: { id, artifactPath, name, level?, toolCallId }.
import React from 'react'
import type { RenderPlugin, PluginAgentSSEEvent } from '../agent'
import SkillDraftCard from '../components/agent/SkillDraftCard'

interface HoistedDraft { name: string; at: string; level?: string }

type SkillDraftPluginState = Map<string, HoistedDraft>

export const skillDraftPlugin: RenderPlugin<SkillDraftPluginState> = {
  eventTypes: ['skill_hoisted'],

  init(): SkillDraftPluginState {
    return new Map()
  },

  // One card per skill name in a tool call: a re-hoist of the same name replaces it.
  reduce(state: SkillDraftPluginState, event: PluginAgentSSEEvent): SkillDraftPluginState {
    const d = event.data as Record<string, unknown>
    const name = d.name as string | undefined
    if (!name) return state
    const next = new Map(state)
    next.set(name, { name, at: event.timestamp ?? '', level: d.level as string | undefined })
    return next
  },

  render({ state, sessionId }) {
    if (state.size === 0) return null
    return (
      <>
        {Array.from(state.values()).map((h) => (
          <SkillDraftCard key={h.name} sessionId={sessionId} name={h.name} at={h.at} level={h.level} />
        ))}
      </>
    )
  },
}

export default skillDraftPlugin
